import { IDataSettingState } from '@/redux/slice/settings.slice';
import styled from 'styled-components';

interface IProps {
  generalSetting: IDataSettingState;
}

export const ShippingFlowStyled = styled.div<IProps>`
  ${(props) => props.generalSetting.custom_css}

  .timeline-layout {
    background-color: ${(props) => props.generalSetting.background_color} !important;
    border: ${(props) => `2px solid ${props.generalSetting.border_color}`} !important;
    font-size: ${(props) => props.generalSetting.text_size + 'px'} !important;
  }

  .timeline-layout--description {
    background-color: ${(props) =>
      props.generalSetting.background_color === 'transparent' ? '#fff' : props.generalSetting.background_color};
    font-size: ${(props) => props.generalSetting.text_size - 1 + 'px'};
  }

  .timeline-layout--svg svg {
    color: ${(props) => props.generalSetting.icon_color} !important;
  }

  .timeline-layout--text span {
    color: ${(props) => props.generalSetting.text_color};
  }
`;
